export default[
    {
        path: '/manage/staffManage',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
          title: '公司-店员管理列表',
          keepAlive: false,
          code: "staff"
        }
    },
    {
        path: '/manage/staffManage/detail/:id',
        component: resolve => require(['../detail.vue'], resolve),
        meta: {
            title: '公司-店员管理详情',
            keepAlive: false,
        }
    },
    {
        path: '/manage/staffManage/updateRecord',
        component: resolve => require(['../updateRecord.vue'], resolve),
        meta: {
            title: '公司-店员修改记录',
            keepAlive: false,
        }
    },
    
]